import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      Common: 'Commom',
      OnlineOrder: 'OnlineOrder',
      leftMenuShow:'leftMenuShow',
      docFontSize:'fontSize',
    })
  },
  methods: {
    ...mapMutations({
      setLeftMenuShow_M:'SET_LEFTMENU_SHOW',
      setLeftMenuIndex_M:"SET_LEFTMENU_INDEX",
      SETLOGNUMBER: 'OnlineOrder/SETLOGNUMBER',
      SETTITLE: 'OnlineOrder/SETTITLE',
    }),
    ...mapActions({
      findOrderList: 'OnlineOrder/findOrderList',
      findProduct: 'OnlineOrder/findProduct',
      findPayType: 'OnlineOrder/findPayType',
      addRemark: 'OnlineOrder/addRemark',
      payRefund: 'OnlineOrder/payRefund',
      findOrderLog: 'OnlineOrder/findOrderLog',
      getRenewQRCode: 'OnlineOrder/getRenewQRCode',
      getPurchaseQRCode: 'OnlineOrder/getPurchaseQRCode',
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/PartII/OnlineOrder/components/Mixins.js